/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header";
import OpportunityForm from "../../components/OpportunityForm";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

function ResumeForJobs() {
  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();


  useEffect(()=>{
    document.title = 'Career Discovery - Nclude Portal'
  },[])
  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);


  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="Jobs"/>
        <div className="doc-container" role="main" tabIndex={-1}>
          <h1 className="display-title" ref={mainRef} tabIndex={-1}>{"Job Opportunities"}</h1>
          <p className="career-text">To get job recommendations please upload your latest resume</p>
          <div className="component-container form-container">
            <OpportunityForm for={"job"}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResumeForJobs;
